const polygonContractAddress = "0x9b8dbe0473493a06A6780872345D620FD440a7a3";// nft

export default polygonContractAddress